module.exports = __webpack_public_path__ + "static/media/85.cfca7165.jpg";